import Component from "./NotFound";
export default Component;
